













export default {
  name: 'SidebarMenuButton',
  emits: ['click'],
};
